export default __webpack_public_path__ + "static/media/undraw_people_tax5.4a2b2244.svg";